<template>
    <div id="mainscroll1" class="roothome_m">

        <div id="mainscroll2" class="wrapper">

            <!--<div id="mainscroll3" style="margin-bottom: 15vh;">-->
                <!-- ################    Top Menu Bar    ################# -->
                <div align="center" class="head0" style="box-shadow: 0px 3px 10px var(--font-dark-gray);">
                    <div align="center" class="head0_2">
                        <div class="head1m">
                            <img src="/static/imgs/ic_back_w.png" alt="menu" class="im_menu2" @click="goToBack()" onMouseOver="this.style.cursor='pointer'">
                            <!--<a href="#" onclick="history.go(-1)"><img src="/static/imgs/ic_back.png" class="im_menu3"></a>-->
                        </div><div class="head2m">



                        <router-link :to="{ params: { stabs: estabs_full, categs: cats_full}, name: 'mHome'}">
                            <span class="tx_logol" > {{ titlePage }}</span>
                            <!--<img src="/static/imgs/advicep_horizontal2_small.png" alt="Logo Advice" class="im_logol">-->
                        </router-link>
                    </div><div  class="head3m">
                        <router-link v-if="!user.sucess" :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat}, name: 'mRegisterUser'}">
                            <div class="di_profile">
                                <img src="/static/imgs/ic_perfil.png" alt="profile" class="im_profile_2">
                            </div>
                        </router-link>
                        <div v-else class="di_profile" style="" @click="showPopEscritorio()">
                            <div v-if='user.foto === ""' class="im_profile_m2" style="justify-content: center; align-items: center; background-color: var(--bg-blue)">
                                <span class="tx_initials" >{{ getInitials(user) }}</span>
                            </div>
                            <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile_2">
                            <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im_profile_2">
                        </div>
                        <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                            <div class="arrow_top"></div>
                            <span class="tx_login_b" >{{ getFirstAndLastWords(user.nome) }}</span>
                            <div class="tx_login" @click.prevent.stop="goToMinhaPagina()">
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.minha_conta) }}</span>
                            </div>
                            <span class="tx_login" >{{ getInterText(inter_ind.configuracoes) }}</span>
                            <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                        </div>
                    </div>

                    </div>
                </div>




                <!-- ################    Foto Profile   ################# -->
                <div style="display: flex; flex-direction: column; align-items: center; margin-top: var(--top-bar-heigth); padding-top: 2vh;">
                    <div v-if='user.foto === ""' class="im_profile_r" style="justify-content: center; align-items: center; background-color: var(--bg-blue)" @click="$refs.inputImage.click()">
                        <span class="tx_initials_r" >{{ getInitials(user) }}</span>
                    </div>
                    <img v-else id="profileImage" :src="profileSrc" alt="Upload Foto" class="im_profile_r" @click="$refs.inputImage.click()">

                    <input style="display: none" ref="inputImage" type="file" accept=".jpg,.jpeg,.png,.tiff,.gif" @change="onFileSelectedOne"/>

                    <div class="bt_procurar" @click="$refs.inputImage.click()" onMouseOver="this.style.cursor='pointer'" tabindex="5" style="margin-bottom: 2vh;">
                        <span class="tx_continuar">{{ getInterText(inter_ind.trocar_foto_perfil) }}</span>
                    </div>

                    <img v-if="photos != null && photos.length > 0 && photos[0].loading" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">
                </div>



                <!-- ################    Form    ################# -->
                <div style="display: flex; flex-direction: column; margin-top: 2%; padding-left: 1.5vw; padding-right: 1.5vw;">
                    <div class="di_form_item" v-for="(item, index) in editing" v-if="index <= 3 || editing[3].editable">
                        <div class="div_nome">
                            <div style="display: flex; flex-direction: row;">
                                <div style="width: 79%;">
                                    <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                    <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                                </div>
                                <div style="display: flex; justify-content: flex-end; width: 20%; cursor: pointer;" @click="alterarCampo(index)">
                                    <span class="tx_form" v-if="index <= 3" :style='editing[index].editable ? "font-weight: bold;" : ""'>{{ getInterText(inter_ind.alterar) }}</span>
                                </div>
                            </div>

                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index < 2 &&  editing[index].editable" tabindex="1"/>
                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index < 2 && !editing[index].editable" tabindex="1" disabled/>
                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index == 2 &&  editing[index].editable" v-on:keyup="mphone(item)" tabindex="1"/>
                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index == 2 && !editing[index].editable" v-on:keyup="mphone(item)" tabindex="1" disabled/>
                            <div style="display: flex; flex-direction: row;" v-if="item.status && index >= 3" >
                                <input :id="item.id" class="input_name_m2" :type='editing[index].show ? "text" : "password"' v-model="item.texto" tabindex="1"/>
                                <img :src='editing[index].show ? "/static/imgs/ic_eye_open.png" : "/static/imgs/ic_eye_close.png"' style="width: 6vw; object-fit: contain;" @click="showPass(index)">
                            </div>
                        </div>
                        <div v-if="index == 0 && (!checkName(editing[index].texto) && editing[index].texto!='')" class="div_aviso">
                            <span class="error_msg">{{ getInterText(inter_ind.nome_invalido) }}</span>
                        </div>
                        <div v-if="index == 1 && (!checkEmail(editing[index].texto) && editing[index].texto!='')" class="div_aviso">
                            <span class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                        </div>
                        <div v-if="index == 3 && (!checkPass(editing[index].texto) && editing[index].texto!='')" class="div_aviso">
                            <span class="error_msg">{{ getInterText(inter_ind.senha_errada_2) }}</span>
                        </div>
                        <div v-if="index == 5 && (!checkPassEquals(editing[index].texto, editing[index - 1].texto) && editing[index].texto!='')" class="div_aviso">
                            <span class="error_msg"> {{ getInterText(inter_ind.senha_errada_3) }}</span>
                        </div>
                    </div>

                    <div style="display: flex; justify-content: left; align-items: center; cursor: pointer; margin-top: 2vh; margin-left: 1%" @click="tryExcludeUser()">
                        <img src="/static/imgs/ic_excluir.png" alt="excluir" style="width: 3.3vh; height: 3vh; object-fit: contain">
                        <span style="font-size: 15pt; margin-left: 1vh; color: var(--font-dark-gray2)">{{ getInterText(inter_ind.excluir_conta) }}</span>
                    </div>

                </div>

                <!-- Espaço -->
                <div style="width: 100%; height: 20vh;"/>

                <!--<div v-if="new_estab.id > 0" style="width: 100%; display: flex; justify-content: center; align-items: center; cursor: pointer;" @click="submitformEstab(false)">-->
                    <!--<img src="/static/imgs/ic_excluir.png" alt="excluir" style="width: 3.3vh; height: 3vh; object-fit: contain">-->
                    <!--<span style="font-size: 2.5vh; margin-left: 1vh; color: var(&#45;&#45;font-dark-gray2)">{{ getInterText(inter_ind.excluir_pagina) }}</span>-->
                <!--</div>-->

                <!-- ################    Botao Enviar    ################# -->
                <div style="padding: 2vh; background-color: var(--bg-purple); text-align: center; bottom: 0; position: fixed; width: 100%;" onMouseOver="this.style.cursor='pointer'" @click="trySubmitformUser(true)">
                    <span style="color: white; font-size: 25pt;">{{ getInterText(inter_ind.enviar) }}</span>
                </div>


            <!--</div>-->
        </div>

        <Alert v-if="showAlert || showConfirm" :textProp="textAlert" :confirmTextProp="getInterText(inter_ind.remover)" :confirmProp="showConfirm" @emit-close="closeAlert" @emit-action="actionFunction"/>

        <filter id="colorize" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.18
                 0 0 0 0 0.24
                 0 0 0 0 0.31
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_cinza" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.33
                 0 0 0 0 0.33
                 0 0 0 0 0.33
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_white" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 1
                 0 0 0 0 1
                 0 0 0 0 1
                 0 0 0 1 0"/>
        </filter>


        <div class="overlay" @click="changeSideBar()"></div>

        <div class="overgalery" @click="showGalery(false)">
            <div class="div_galery" @click.stop.prevent="">
                <img  v-if="estab.tbFotos!=null" :src="baseUrlImg + '/MARCADOR/' + estab.tbFotos[getPhotoIndex(0)].file" alt="Foto Principal" class="imgGalery"/><br>
                <div class="div_arrow_l">
                    <img src="/static/imgs/ic_left_2.png" onmouseover="this.src='/static/imgs/ic_left.png'; this.style.cursor='pointer';" onmouseout="this.src='/static/imgs/ic_left_2.png'" alt="Foto Anterior" @click="nextPhoto(-1)" class="im_arrow">
                </div>
                <div class="div_arrow_r">
                    <img src="/static/imgs/ic_right_2.png" onmouseover="this.src='/static/imgs/ic_right.png'; this.style.cursor='pointer';" onmouseout="this.src='/static/imgs/ic_right_2.png'" alt="Foto Anterior" @click="nextPhoto(+1)" class="im_arrow">
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { advMixin } from '../scripts/advMixin'



    export default {
        mixins: [advMixin],
        name: 'mEditUser',
        data () {
            return {
                name: 'mEditUser',
                editing: [
                    {
                        id: 'zeroID',
                        campo: 'Nome',
                        texto: '',
                        status: false,
                        editable: false,
                        show: false,
                    },
                    {
                        id: 'umID',
                        campo: 'E-mail',
                        texto: '',
                        status: false,
                        editable: false,
                        show: false,
                    },
                    {
                        id: 'doisID',
                        campo: 'Telefone',
                        texto: '',
                        status: false,
                        editable: false,
                        show: false,
                    },
                    {
                        id: 'tresID',
                        campo: 'Senha Atual',
                        texto: '',
                        status: false,
                        editable: false,
                        show: false,
                    },
                    {
                        id: 'quatroID',
                        campo: 'Nova Senha',
                        texto: '',
                        status: false,
                        editable: true,
                        show: false,
                    },
                    {
                        id: 'cincoID',
                        campo: 'Confirmar Nova Senha',
                        texto: '',
                        status: false,
                        editable: true,
                        show: false,
                    },

                ],
                editingLogin: [
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                ],

                estabs: [],
                estab: [],
                estabs_full: [],
                cat: {},
                search_text: "",
                photoIndex: 0,
                showShare: false,
                showingSearch: false,
                actualWidth: 0,
                showCats: false,
                cepOk: true,
                showAddress: false,
                loading: {
                    cats: false,
                    estabs: false
                },
                response: {
                    status: "ok"
                },
                // tituloCat: "",
                // corCat: "",
                // corCat2: "#E4E4E4",
                msg_erros: [

                ],
                transpGif: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
            }
        },
        methods: {
            showCategorias() {
                this.showCats = !this.showCats;
            },
            selectCat(index) {
                console.log('selecCat index ' + index);
                this.cats_full[index].deleted = !this.cats_full[index].deleted;
            },
            shuffle(array) {
                var tmp, current, top = array.length;
                if(top) while(--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }
                return array;
            },
            handleResize (event) {
                this.actualWidth = window.innerWidth;
                // console.log('window.innerWidth: ' + actualWidth);
            },
            trimAll(str){
                return str.replace(/\s/g,'');
            }
        },
        created() {
            console.log(name + '::created!!');

            this.new_estab.id = -1;

            this.titlePage = this.getInterText(this.inter_ind.configuracoes);

            this.profileSrc = this.baseUrlImg + "PROFILE/" + this.user.foto;
            if (this.hasHttp(this.user.foto)) {
                this.profileSrc = this.user.foto;
            }

            this.editing[0].campo = this.getInterText(this.inter_ind.nome);
            this.editing[1].campo = 'E-mail';
            this.editing[2].campo = this.getInterText(this.inter_ind.telefone);
            this.editing[3].campo = this.getInterText(this.inter_ind.senha_atual);
            this.editing[4].campo = this.getInterText(this.inter_ind.senha_nova);
            this.editing[5].campo = this.getInterText(this.inter_ind.senha_nova_confirma);

            this.editing[0].texto = this.user.nome;
            this.editing[1].texto = this.user.email;
            this.editing[2].texto = this.user.fone;

            for (let i = 0 ; i < 6; i++)
                this.editing[i].status = true;


            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                if (this.$route.params.stab) {
                    console.log('Usando new_estab passados por parametro!!');

                    this.new_estab = this.$route.params.stab;
                    console.log('new_estab: ', this.new_estab);


                    this.fillFieldsEstab(this.new_estab);
                }
            }
            else {
                console.log('Baixando estabs!!');
                this.getEstabsCats();
            }

            console.log('Terminei o created!!');
        },
        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },
        mounted() {
            console.log('mounted!!');

            this.barra_pat = this.shuffle(this.barra_pat);

            console.log('Terminei o mounted!!');
        },
    }
</script>

<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/adv.css" scoped/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .head0_2 {
        background-image: linear-gradient(var(--bg-blue-grad1), var(--bg-blue-grad2));
        height: var(--top-bar-heigth);
        width: 100vw;
        display:block;
        margin:auto;
        position:relative;
        font-size: 0;
        display: flex;
    }
    .div_arrow_l, .div_arrow_r {
        position: absolute;
        top:0;
        height: 100%;
        min-width: 40px;
        vertical-align: center;
    }
    .div_arrow_r {
        right: 2px;
    }
    .div_arrow_l {
        left: 2px;
    }
    .im_arrow {
        position: absolute;
        vertical-align: middle;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        padding-top: 30px;
        padding-bottom: 30px;
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -o-transition: all 1s ease;
        -ms-transition: all 1s ease;
        transition: all 1s ease;
    }
    .im_arrow:hover {
        -webkit-filter: brightness(70%);
        filter: brightness(70%);
    }

    .overgalery {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: rgba(10, 10, 10, 0.85);
        z-index: 1;
        display: none;
        vertical-align: middle;
        top: 0;
    }
    .div_galery {
        vertical-align: middle;
        display: inline-block;
        z-index: 1;
        position: relative;
        top: 50%;
        left: 50%;
        padding-right: 10px;
        padding-left: 10px;
        transform: translate(-50%, -50%);
    }
    .imgGalery {
        width: 95vw;
        object-fit: fill;
    }

    .di_form_item {
        display: flex;
        flex-direction: column;
        background: white;
        border-radius:10px;
        margin-right: 0.5%;
        margin-left: 0.5%;
        margin-bottom: 2%;

        padding-right: 2%;
        padding-left: 5%;
        padding-bottom: 2%;
        padding-top: 2%;
    }


    @-webkit-keyframes rotation {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(359deg);
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/mEditUser.vue